import type { ICellRendererParams } from 'ag-grid-community';
import { IBlotterQuoteItem } from 'models/IBlotterItem';
import { FC } from 'react';

import { AddToOrderBasketButton } from './AddToOrderBasketButton';

export const AddToOrderBasketCellRenderer: FC<ICellRendererParams<IBlotterQuoteItem>> = ({ data }) => (
  <AddToOrderBasketButton data={data!} />
);
